const getGameColors = (game) => {
  switch (game) {
    case "Ramadan":
      return {
        gamebg: "#c3cb92",
        keybordKey: "#6b8254",
        keybordfont: "#fff",
      };
    case "Easter":
      return {
        gamebg: "#dfc57b",
        keybordKey: "#bf9328",
        keybordfont: "#fff",
      };
    case "Movie":
      return {
        gamebg: "#dcedf5",
        keybordKey: "#6085a2",
        keybordfont: "#fff",
      };
      case "Vishu":
        return {
          gamebg: "#f5f5b0",
          keybordKey: "#E1B722",
          keybordfont: "#fff",
        };
     
    default:
      return {
        gamebg: "#fff9dd",
        keybordKey: "#c1856d",
        keybordfont: "#fff",
      };
  }
};

const Colors = {
  /*** First Set Colors ***/

  // bgColor:'#CBDBFF',
  // Tidesbg: '#FFFFFF',
  // Tidesfont: '#202f75',
  // button1: '#F18D9E',
  // button1Border: '#B14E64',
  // button2: '#5BC8AC',
  // button2Border: '#2A5E4F',
  // boxBorderColor:'#FFFFFF',
  // nameBg:'#FFFFFF',
  // headerBorder:'#FFFFFF',
  // avatarButton:'#503259',

  /*** First Set Colors ***/

  // bgColor: '#ECD4EA',
  // Tidesbg: '#FFF',
  // Tidesfont: '#451952',
  // button1: '#693B69',
  // button1Border: '#B72B41',
  // button2: '#c383b4',
  // button2Border: '#582040',
  // boxBorderColor: '#FFF',
  // nameBg: '#ECD4EA',
  //headerBg:'#000',
  // headerBorder: '#FFF',
  // avatarButton:'#693B69',
  // micGrey:'#999798',
  // tab1color:'#a42153',
  // tab2color:'#62021e',
  // keybordKey:'#dbbfd8'

  bgColor: "#FFF",
  signupbg: "#EACABB",
  landingBox: "#f8f2e9",
  Tidesbg: "linear-gradient(to bottom, #F8EFE8, #F8EFE8, #EACABB)",
  Tidesfont: "#451952",
  button1: `linear-gradient(85deg, #e8c8b1 20%, #66442b 80%)`,
  button1Border: "#401d07",
  button1font: "#fff",
  button2: `linear-gradient(135deg, #f0d8c4 20%, #e6c2aa 100%)`,
  button2font: "#401d07",
  button2Border: "#401d07",
  boxBorderColor: "#FFF",
  nameBg: "#FFF",
  headerBorder: "#F9F9F9",
  headerBg: "#FFF",
  footerbg: "#dce8da",
  avatarButton: "#9f0358",
  micGrey: "#3F2C2A",
  tab1color: "#a42153",
  tab2color: "#62021e",
  dailyPuzle: "#ededed",
  puzzlebg: "linear-gradient(to bottom, #F9B2A4, #FCD697, #FAA996)",
  privatePuzle: "#e6eaba",
  privatepuzzlebg: "linear-gradient(to bottom, #A5C4C2, #B5CB9A, #8EA79C)",
  privatename: "#FFF",
  yellowflake: "#DFB724",
  orengeflake: "#F5801C",
  redflake: "#5b0503",
  greenflake: "#53BA6F",
  AllgameBg: "#ddb8b7",
  gameboxbg: "linear-gradient(to right top, #DAAAB6, #772239, #F6D6E1)",
  gamedatebg: "#f9d9e4",
  rapidbg: "#f0ecde",
  signupboxbg: "linear-gradient(135deg, #3F2C2A, #1C1924, #3F2C2A)",
  signupBorder: "#ee8e4c",
  controlButton: "#2a4852",
  controlbuttonfont: "#fff",
  tabbutton: "#629fb1",
  tabbuttonfont: "#fff",
  activetabbutton: "#417583",
  activetabbuttonfont: "#fff",
  keyboardbutton: "#af95b2",
  keyboardbuttonfont: "#000",
  chinnangal: "#6f5767",
  chinnangalfont: "#fff",
  ...getGameColors(localStorage.getItem("RapidGame")),
  //  gamebg:'#dcedf5',
  //  keybordKey:'#6085a2',
  //   keybordfont:'#fff'
};

export default Colors;
